'use client';

import useModal from '@/hooks/useModal';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

function ScrollUnlocker() {
  const pathname = usePathname();
  const { closeModal } = useModal();

  useEffect(() => {
    document.body.style.overflow = 'auto';
    document.body.classList.remove('no-scroll');
    closeModal();
  }, [pathname]);

  return null;
}

export default ScrollUnlocker;
